import React, { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { CircularProgress, Backdrop } from '@mui/material';
import MainLayout from './components/MainLayout';

// Lazy load das páginas
const EntitySelection = lazy(() => import('./pages/EntitySelection'));
const EntityDashboard = lazy(() => import('./pages/EntityDashboard'));
const FilteredInformationList = lazy(() => import('./pages/FilteredInformationList'));

const AppRoutes: React.FC = () => {
  return (
    <Suspense
      fallback={
        <Backdrop open={true} sx={{ color: '#fff', zIndex: 9999 }}>
          <CircularProgress color="inherit" />
        </Backdrop>
      }
    >
      <Routes>
        {/* Rota raiz => seleção de entidade */}
        <Route
          path="/"
          element={
            <MainLayout>
              <EntitySelection />
            </MainLayout>
          }
        />

        {/*
          :entName é opcional (usamos o "?").
          Exemplo de acesso:
          /entidade/249
          /entidade/249/prefeitura-municipal-de-marcionilio-souza
        */}
        <Route
          path="/entidade/:id/:entName?"
          element={
            <MainLayout>
              <EntityDashboard />
            </MainLayout>
          }
        />

        <Route
          path="/entidade/:id/:entName/categoria/:categoryId"
          element={
            <MainLayout>
              <FilteredInformationList />
            </MainLayout>
          }
        />

        <Route
          path="/entidade/:id/:entName/autor/:author"
          element={
            <MainLayout>
              <FilteredInformationList />
            </MainLayout>
          }
        />

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;